export class EpgChannelGenre {
  public static readonly FAVORITE_GENRE_ID: number = 39441;
  public static readonly FEATURED_GENRE_ID: number = 39451;
  private _title: string;
  private _id: number;

  constructor(
    id: number,
    title: string,
  ) {
    this._id = id;
    this._title = title;
  }

  get title(): string {
    return this._title;
  }

  get id(): number {
    return this._id;
  }

  get isFavorite(): boolean {
    return this._id === EpgChannelGenre.FAVORITE_GENRE_ID;
  }

  get isFeatured(): boolean {
    return this._id === EpgChannelGenre.FEATURED_GENRE_ID;
  }
}
